import { PropertiesFile } from "../types";
import { SavedRow } from "../types";
export function to_saved_row(props: PropertiesFile|null) : Array<SavedRow> {
  let sr: SavedRow[] = [];
  if(!props){
    return sr;
  }
  for(const key in props){
    sr.push(props[key]);
  }
  return sr;
}

